import api from '@/util/app-api'

export const state = {
  organizations: [],
  fetched: false
}

export const mutations = {
  set(state, organizations) {
    state.organizations = [].concat(organizations)
    state.fetched = true
  },
}

export const actions = {
  async fetch({ state, commit }, options) {
    options = Object.assign({ force: false }, options)

    if (state.fetched && !options.force)
      return state.organizations
    
    return api.get('admin/organization/List/', null)
    .then(data => {
      commit('set', data)
      return data
    })
  }
}

export const getters = {
  all: state => {
    return state.organizations
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
